import React, { Component, Fragment } from "react";

import Moment from 'react-moment';
// import 'moment-timezone';

// import firebase from "../../firebase";
import {MyStore} from '../../../../services/Store'
import { Route, NavLink, Link, Redirect, withRouter} from 'react-router-dom';
import {
    Menu,
    Icon,
    Modal,
    Form,
    Input,
    Button,
    Message,
    Label,
    Container,
    Card,
    Image, 
    Grid, 
    Dropdown
} from "semantic-ui-react";

const _ = require('lodash/fp/object')

class CardProject  extends Component {
        constructor(props){
        super(props)
        // console.log(props)

        // this.mbrProjectsRef= MyStore.database().ref("groups").child(groupId).child('mbrprojects').child(currentUser.uid)

        
        this.state = {
            user: this.props.currentUser,
            // user: MyStore.auth().currentUser,
            // notifications: this.props.notifications,
            activeConvoId: props.activeConvoId,
            groups: [],
            showModal: false,
            groupName: "",
            groupDetails: "",
            groupsRef:   MyStore.database().ref("groups"),
            // cardsRef: MyStore.database().ref('cards').child('-LwLujWwcsr6szQxZYer'),
            // cardsRef: MyStore.database().ref('cards').child(this.props.oid),
            // dmRef: MyStore.database().ref("directMessages"),
            usersRef:   MyStore.database().ref("users"),
            // groupsRef: MyStore.database().ref().child("groups"),
            // dmRef: MyStore.database().ref().child("directMessages"),
            firstLoad: true,
            errors: [],
            activeItem: props.activeConvoId,
            members: {},
        };
    }


    displayDraft(group) {

        if (group.draft === true) {
          return <Label color='teal' ribbon='right' style={{ marginRight: "150px" }} > Draft </Label>
        }
        else {
          return <Label color='blue' ribbon='right' style={{ marginRight: "150px" }} > Complete </Label>
        }
    
    
      }


   isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
    
  //  cardMembers(group){
     

  //   MyStore.database().ref().child(`/groups/${this.props.oid}`).child('mbrcards').child(group.filelogid).on('value', snap => {
  //     console.log(snap.val())

  //     let myArr = []
  //     console.log('----------- function 02 -------------')
  //     console.log(snap.val())

  //     for (const key in snap.val()) {
  //         myArr.push(Object.assign({}, snap.val()[key]));
  //     }
  //     if (snap.val() != null) {
  //         // users = myArr
  //         // cg = myArr/
  //         this.setState({members: myArr})
  //         // console.log(myArr)
  //         // setState({myArr})
  //     }
  //   })

  
  //  }
  cardMembers(group){
    let avatar = group.avatar
    if(avatar){
      // console.log('inside avatar line 103')
      // console.log(avatar)
    }
  }
    
    handleItemClick = (e, { name }) => {
        this.setState({ activeItem: name })
        // this.handleItemClick()
    }

    nextPath(path) {
        this.props.history.push(path);
      }


    displayErrors = errors =>
        errors.map((e, index) => <p key={index}>{e.message}</p>);

    displayGroups = groups =>
        groups.length > 0 &&
        groups.map(group => (
          

<Card  style={{ width: '24vh', marginLeft: '1vw'}}>

{/* <Image  src={image} wrapped ui={false} /> */}
<Card.Content>
{this.displayDraft(group)}
  {/* {this.handleProjectStatus(item.projectCompleted)}  */}
  {/* {this.handleProjectStatus()} */}

  {/* {this.function(item.projectCompleted)} */}
  {/* <Label color='teal' ribbon='right'style={{marginRight:"150px"}} > Draft </Label> */}

        <Card.Header>{group.mrn}  </Card.Header>
        <Card.Header> {group.name}</Card.Header>
        <Card.Meta style={{ marginTop: "10px" }}>

              {/* <span className='date'>{group.title}</span> */}

        {/* <p> <Moment format={"dddd, MMMM Do YYYY, h:mm:ss a"} date={group.date}/></p> */}

 

  </Card.Meta>
{/* 
  <Card.Meta style={{ marginTop: "10px" }}>
    <span className='date'>{group.description}</span>
  </Card.Meta> */}
 {/* <Moment date=  {group.date}/> */}
<Card.Description>

   <p>
   {group.age}   {group.gender} 

   
     </p> 
 
     <p>
       {/* {group.date} */}
     </p>
  </Card.Description>
  
  <Card.Description>
    {/* {group.text} */}
      {/* <Moment date=  {group.date}  type="datetime-local"/> */}
  </Card.Description>
</Card.Content>

  {/* {this.cardMembers(group)} */}
{/* <Card.Description style={{ width: '25vh'  }}>


  <Image

    floated='left'
    size='mini'
    src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
  //   src={physician03}
  />

<Image

floated='left'
size='mini'
src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
//   src={physician03}
/>

<Image

floated='left'
size='mini'
src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
//   src={physician03}
/>

  <Image

    floated='left'
    size='mini'
    src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
  //   src={physician03}
  />
  
</Card.Description> */}







{/* <Link to={`/cadre/${this.context.oid}/dashboard/card/${group.cardId}`} className="btn btn-success w-25">
  <span>
    <i className="fas fa-edit"  /> <p>Edit</p>
  </span>
</Link> */}



{/* <p>Edit 2</p>
<Link to={`/cardlist/card/edit2/${id}`} className="btn btn-success w-25">
<span>
  <i className="fas fa-edit" /> <p>Edit 2</p>
</span>
</Link> */}

{/* <Link to="route" target="_blank" onClick={(event) => {event.preventDefault(); window.open(this.makeHref("route"));}} /> */}

{/* <Link
 
to={
  {
    pathname:`/cardlist/card/edit/${group.cardId}`,
    state:{
      from:'projectCards'
    }
  }
}

className="btn btn-success w-25" 

>

  <button
    className="btn btn-warning w-75 mr-1"
  >

    <span>
      <i className="fas fa-edit" /> <p>Edit</p>
    </span>{' '}

  </button>
</Link> */}

{/* <button class="ui button">Basic Modal {this.ModalBasicExample} </button> */}
{/* <Button content='Open' onClick={this.handleOpen} /> */}
{/* 
<Button
onClick={() => this.cardModal(group.cardId)}
>

</Button> */}

{/* {this.cardModal(group.cardId)} */}
<Button 
// onClick={() => this.props.changeGroup(group)}
onClick={() => this.props.modalState(true, group)}
// onClick={() => this.setState({ open: true })}

>

<i className="fas fa-edit" />  
  Edit

</Button>


<Card.Content extra>
  <p  style={{ fontSize: '.75em' }}>last update</p>
<i> <Moment format={ "YYYY-MM-DD HH:mm"} date={group.date}/></i>
  {/* <a>
<Icon name='user' />
{this.getMemberLength(group)}  
</a> */}
</Card.Content>

<Button
  className="btn btn-warning w-75 mr-1"
//   onClick={() => this.onDeleteClick(id, dispatch, auth)}
>
  <span>
    <i className="far fa-trash-alt" />
  </span>{' '}  
Remove
</Button>


<Card.Content extra style={{ background: "black", color: "white" }}>
  {/* <p>4 images</p> */}
 <h4 style={{textAlign:'center'}}>   <Icon name='user' /> 2</h4>
  {/* {this.getMemberLength(group)} */}
</Card.Content>
</Card>
        ));


        // displayCards = groups =>
        // groups.length > 0 &&
        // groups.map(group => (
        //     <Card.Group 
        //         key={group.cardId}
        //         onClick={() => this.props.changeGroup(group)}
               
        //         name={group.name}
        //         style={{  background: '#77E97F', color: '#6D6D6D' }}
        //         // active={group.id === this.state.activeConvoId}
        //          active={this.state.activeItem === group.mrn}
                 
        //         >
                    
        //                <Label>51</Label>
        //          {group.age}  {group.gender}  {group.name}  {group.mrn}

        //          {/* (this.state.age)+' ' + (this.state.gender)  + ' ' + (this.state.name) +' '+ (mrn)  */}
        //         {/* {this.getNotifications(group.id) > 0 && (
        //             <Label color="red">{this.getNotifications(group.id)}</Label>
        //         )} */}

        //     </Card.Group>
        // ));
    
    toOrgan=(e)=>{
        // e.preventDefault()
        
        // console.log(e)
        // console.log(e.target.value)
        this.nextPath(`/dashboard/${e.target.value}`)
       
        // console.log('------------id  groups.js')

    }

  

    // openModal = () => {
    //     this.setState({
    //         showModal: true
    //     });
    // };

    // closeModal = () => {
    //     this.setState({
    //         showModal: false
    //     });
    // };

 

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };


    /**
     * Set initial active group to first group in state
     * upon first page load
     */
    setFirstGroup = () => {
        const { groups, firstLoad } = this.state;
        if (firstLoad && groups.length > 0) {
            this.props.changeGroup(groups[0]);
        }
        this.setState({ firstload: false });
    };

    

    addGroupToUser = (snap, groupId) => {
        const { user, usersRef } = this.state;
        let userGroups = snap.child("groups").val();

        if (!userGroups) {
            userGroups = {};
        }

        userGroups[groupId] = {
            groupId: groupId,
            isMember: true
        };

        usersRef.child(user.uid).update({
            groups: userGroups
        });
    };


    /**
     * Add groups belonging to user into component state so that
     * users will only see groups in the sidebar that they are
     * a member of
     */
    addGroupListener = () => {
        let loadedGroups = [];
        const { user, usersRef, groupsRef } = this.state;
        // console.log(usersRef)
        // const { addNotificationListener } = this.props;

        // Listen for new groups in groups child under users ref
        if(user){
            MyStore.auth().onAuthStateChanged(() => {
          
                const loadedGroups = [];
                    // mbrProjectsRef.child('cards')
                    // MyStore.database().ref("groups").child('-LwLujWwcsr6szQxZYer').child('mbrprojects').child(user.uid).child('cards')
                    MyStore.database().ref("groups").child(this.props.oid).child('mbrprojects').child(user.uid).child('cards')
    
                    .on("child_added", snap => {
                        let cardId = snap.val().id;
                        // console.log(cardId)
                        // groupsRef.child('-LwLujWwcsr6szQxZYer').child('cards').child(cardId).once("value", snap => {
                          groupsRef.child(this.props.oid).child('cards').child(cardId).once("value", snap => {
                            let data = snap.val();
                            if(data){
                              loadedGroups.push(Object.assign({},data));
                            }
                         
                            
                            
                          
                        });
                                //  console.log(loadedGroups)
                                 this.setState({groups:loadedGroups })
                        if (snap.val() == null) {
                            this.setState({groups: []})
               
                      }
             
                    });
            
         
                  })

  
        }
        else{
            return
        }

    };

    removeGroupListener = () => {
        this.state.usersRef.off();
    };

    /**
     * COMPONENT LIFECYCLE METHODS
     */
    static getDerivedStateFromProps(nextProps) {
        return {
            activeConvoId: nextProps.activeConvoId
        };
    }

    componentDidMount() {
      // console.log(this.props)
        this.addGroupListener();
    }

    // componentDidUpdate(){
    //     this.addGroupListener();
    // }

    componentWillUnmount() {
        this.removeGroupListener();
    }


    loadChatRoom(activeItem, groups){
        return(
            <React.Fragment>
 
 <Card.Group itemsPerRow={6} style={{ marginLeft: "5vw" }}>
 {this.displayGroups(groups)}

 </Card.Group>
 
 


 

  </React.Fragment>
        )
    }

    render() {
        const { activeItem, groups } = this.state
        return (
            <Fragment>

            {this.loadChatRoom(activeItem, groups)}
            </Fragment>
        );
    }
}

export default CardProject;
// export default withRouter(PatientProject);